import { z } from "zod";
import { defineEvent } from "./registry.js";
/**
 * Bütçe sapma alarmı. Yük KİŞİSEL VERİ TAŞIMAZ. Bütçe + hücre + ay başına BİR kez üretilir
 * (`budget_variance_alerts` tekil dizini). Yalnızca OLUMSUZ ve eşiği AŞAN sapmalar alarmdır.
 */
export const budgetVarianceExceededV1 = defineEvent({
    type: "budget.variance.exceeded",
    version: 1,
    description: "Bütçe sapması eşiği aştı (gider fazlası ya da gelir eksiği)",
    realtime: ["tenant"],
    payload: z.object({
        companyId: z.uuid(),
        budgetId: z.uuid(),
        fiscalYear: z.number().int(),
        month: z.number().int(),
        stationId: z.uuid().nullable(),
        accountPrefix: z.string(),
        nature: z.enum(["REVENUE", "EXPENSE"]),
        /** Kuruş (dizge). */
        budgetAmount: z.string(),
        actualAmount: z.string(),
        /** Bütçeye göre yüzde; bütçesiz harcamada null. */
        percent: z.string().nullable(),
    }),
});
//# sourceMappingURL=budget.v1.js.map